<!-- 全局顶部提示插件框 -->
<template>
  <transition name='message'>
    <div class='fixed-message' v-show="visible">
      <div v-show="type === 'success'" class="success fixed-message__content">{{txt}}</div>
      <div v-show="type === 'fail'" class="fail content fixed-message__content">{{txt}}</div>
      <div v-show="type === 'warning'" class="warning content fixed-message__content">{{txt}}</div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      visible: false,
      txt: '',
      type: ''
    }
  }
}
</script>
<style lang='less' scoped>
@w2: 75rem;
.fixed-message {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 74 / @w2;
  &__content {
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 30 / @w2;
    text-align: center;
    line-height: 74 / @w2;
    position: relative;
    top: 0;
  }
}
.message-enter-active {
  animation: message .5s;
}
.message-leave-active {
  animation: message .2s reverse;
}

@keyframes message {
  0% {
    top: -74 / @w2;
  }
  100% {
    top: 0;
  }
}

.success {
  background: #07c160;
}

.fail {
  background: #e95552;
}

.warning {
  background: #ff976a;
}
</style>
